import React, { useState, useEffect, useCallback } from 'react'
import RightArrow from '../../common/icons/right-arrow'
import { useTranslation } from 'react-i18next'
import { _Api } from '../../api/_call'
import './barcode.scss'
import TableLoader from '../../common/TableLoader'
import Select from 'react-select'
import { Pagination } from '../../common/Pagination'
import SearchIcon from '../../common/icons/SearchIcon'
import CloseIcon from '../../common/icons/CloseIcon'

const BarcodeLogs = () => {
  const { t } = useTranslation();
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const [showloader, setShowloader] = useState(false);
  const { totalPages, currentPage } = state;
  const [showSearch, setShowSearch] = useState(false);
  const [filtername, setFiltername] = useState('');
  const [limit, setLimit] = useState(100);
  const [logdata, setLogdata] = useState([]);

  const getlogdata = useCallback(async (current = 1, firstlimit, searchValue, options = {}) => {
    const silent = Boolean(options.silent);
    if (!silent) setShowloader(true);
    try {
      const pageLimit = firstlimit ? firstlimit : limit;
      const skipNumber = current ? (current - 1) * pageLimit : 0;
      const postdata = {
        search: searchValue !== undefined ? searchValue : filtername,
        limit: pageLimit,
        skip: skipNumber,
      };
      const res = await _Api(postdata, `api/v1/barcode/print-log/list`);
      if (res?.code === 200) {
        setLogdata(Array.isArray(res?.data) ? res.data : []);
        setstate({
          totalPages: Math.ceil((res?.total || 0) / pageLimit) || 0,
          currentPage: current ? current : 1,
        });
      } else {
        setLogdata([]);
        setstate({ totalPages: 0, currentPage: 1 });
      }
    } catch (err) {
      console.log(err, "err");
      setLogdata([]);
    } finally {
      if (!silent) setShowloader(false);
    }
  }, [filtername, limit]);

  useEffect(() => {
    getlogdata(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaginations = (current) => {
    setstate((prev) => ({ ...prev, currentPage: current }));
    getlogdata(current);
  };

  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    getlogdata(1, nextLimit);
  };

  const filterbyname = () => {
    getlogdata(1);
  };

  const clearSearch = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    const hadSearch = Boolean(filtername?.trim());
    setFiltername("");
    setShowSearch(false);
    if (hadSearch) {
      getlogdata(1, limit, "", { silent: true });
    }
  };

  const toggleSearchBar = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (showSearch) {
      setFiltername("");
      setShowSearch(false);
      return;
    }
    setShowSearch(true);
  };

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]

  return (
    <>
      <div className="main-content-wrapper-body barcode-logs-page setup-sticky-header">
        <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
          <div className="main-content-wrapper-body-top-bar-left">
            <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
              {t('Setup')} <RightArrow />{t('Barcode')} <RightArrow />
              <span className="">{t('Logs')}</span>
            </h1>
          </div>
        </div>
        <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center justify-content-between">
          <Select
            className="limit-select"
            options={selectOptions}
            value={{ label: limit, value: limit }}
            onChange={(e) => { setLimit(e.value); getlimit(e.value) }}
          />
          <div
            className={`com-search-bar2 barcode-search-bar position-relative ${showSearch ? "active" : ""}`}
          >
            <span className="com-search-bar2-searchbar" onClick={toggleSearchBar}>
              <SearchIcon />
            </span>
            <input
              placeholder={t("Search by user, SKU, stock ID, template")}
              className="h-100 border-0 bg-transparent"
              value={filtername}
              onKeyDown={(e) => e.key === 'Enter' && filterbyname()}
              onChange={(e) => setFiltername(e.target.value)}
            />
            <span
              className="com-search-bar2-closeicon"
              onClick={clearSearch}
              role="button"
              tabIndex={showSearch ? 0 : -1}
              aria-hidden={!showSearch}
              onKeyDown={(e) => e.key === 'Enter' && clearSearch(e)}
            >
              <CloseIcon />
            </span>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-12">
            <div
              className="main-body-main-table-wrap com-custom-table table-responsive position-relative"
            >
              <table
                id="my_customer"
                className="com-custom-table-tag table align-middle">
                <thead>
                  <tr className="bg-white text-nowrap align-middle">
                    <th className="bg-white">#</th>
                    <th className="bg-white">{t("User")}</th>
                    <th className="bg-white">{t("Date & Time")}</th>
                    <th className="bg-white">{t("SKU")}</th>
                    <th className="bg-white">{t("Stock ID")}</th>
                    <th className="bg-white">{t("Template")}</th>
                  </tr>
                </thead>
                <tbody>
                  {logdata.length > 0 ? logdata.map((result, key) => {
                    const rowNumber = ((currentPage - 1) * limit) + key + 1;
                    return (
                      <tr className="hoverrow text-nowrap" key={result?.id || key}>
                        <td><span>{rowNumber}</span></td>
                        <td><span>{result?.user ? result.user : "-"}</span></td>
                        <td>
                          <span>
                            {result?.date_time
                              ? result.date_time
                              : `${result?.date || "-"} ${result?.time || ""}`.trim()}
                          </span>
                        </td>
                        <td><span>{result?.SKU || "-"}</span></td>
                        <td><span>{result?.stockid ? result.stockid : "-"}</span></td>
                        <td><span>{result?.template ? result.template : "-"}</span></td>
                      </tr>
                    )
                  }) :
                    !showloader && (
                      <tr>
                        <td colSpan="50" className="text-center">
                          {' '}
                          {t("No Data Available In Table")}
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
              {showloader && <TableLoader />}
            </div>
            {logdata.length > 0 && (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            )}
          </div>
        </div>
      </div>

    </>
  )
}

export default BarcodeLogs
